import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import backgroundImage from "../assets/fondos/zamurai.jpg";
import logvefase from "../assets/logok.png";
import "../assets/css/login.css";

const URL_REGISTRO = "https://api.mrcirp.com/public/loginusuarios";

const RegistroDemo = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const emailParam = searchParams.get("email") || "";

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    nombreuser: "",
    username: emailParam,
    password: "",
    confirmPassword: "",
    membresia: "Katana Demo",
    rol: "cliente",
    status: "activo",
  });

  useEffect(() => {
    if (emailParam) {
      setFormData((prev) => ({
        ...prev,
        username: emailParam,
      }));
    }
  }, [emailParam]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (formData.password !== formData.confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    if (formData.password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        username: formData.username,
        password: formData.password,
        nombreuser: formData.nombreuser,
        membresia: "Katana Demo",
        rol: "cliente",
        status: "activo",
      };

      const res = await axios.post(URL_REGISTRO, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (res.data?.Result && res.data.Result.startsWith("Error")) {
        setError(res.data.Result);
        return;
      }

      setSuccess(true);
      setTimeout(() => navigate("/"), 3000);
    } catch (err) {
      const msg =
        err.response?.data?.Result ||
        err.response?.data?.message ||
        "Error al crear la cuenta. Intenta de nuevo.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="bodylogin">
        <div className="video-background">
          <img src={backgroundImage} alt="Background" className="background-image" />
        </div>
        <div className="container">
          <div className="login-register">
            <div className="row">
              <div className="col-md-4 offset-md-4 col-sm-10 offset-sm-1 mt-4">
                <div className="card login-box">
                  <div className="card-body text-center">
                    <img src={logvefase} alt="KATANA" width={200} style={{ maxWidth: "100%", height: "auto" }} />
                    <h5 className="mt-4 text-success">¡Cuenta creada con éxito!</h5>
                    <p className="text-muted">
                      Tu demo de 15 días de KATANA está activa. Serás redirigido al inicio de sesión...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bodylogin">
      <div className="video-background">
        <img src={backgroundImage} alt="Background" className="background-image" />
      </div>
      <div className="container">
        <div className="login-register">
          <div className="row">
            <div className="col-md-4 offset-md-4 col-sm-10 offset-sm-1 mt-4">
              <div className="card login-box">
                <div className="card-body" style={{ textAlign: "left" }}>
                  <div className="form-horizontal form-material text-center">
                    <img src={logvefase} alt="KATANA" width={200} style={{ maxWidth: "100%", height: "auto" }} />
                    <h5 className="mt-3 mb-3">Crear cuenta - KATANA DEMO</h5>
                    <p className="text-muted small mb-3">
                      Demo gratuita de 15 días. Completa tus datos para crear tu cuenta.
                    </p>

                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <div className="col-sm-12">
                          <input
                            className="form-control"
                            name="nombreuser"
                            type="text"
                            required
                            placeholder="Nombre completo"
                            value={formData.nombreuser}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="col-sm-12">
                          <input
                            className="form-control"
                            name="username"
                            type="email"
                            required
                            placeholder="Correo electrónico (usuario)"
                            value={formData.username}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="col-sm-12">
                          <div className="input-group">
                            <input
                              className="form-control"
                              name="password"
                              type={showPassword ? "text" : "password"}
                              required
                              placeholder="Contraseña (mín. 6 caracteres)"
                              value={formData.password}
                              onChange={handleChange}
                            />
                            <div className="input-group-append">
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? <FaIcons.FaEyeSlash /> : <FaIcons.FaEye />}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="col-sm-12">
                          <input
                            className="form-control"
                            name="confirmPassword"
                            type={showPassword ? "text" : "password"}
                            required
                            placeholder="Confirmar contraseña"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {error && (
                        <div className="alert alert-danger">
                          <small>{error}</small>
                        </div>
                      )}

                      <div className="form-group text-center">
                        <div className="col-xs-12 p-b-20">
                          <button
                            type="submit"
                            disabled={loading}
                            style={{
                              backgroundColor: "#52c41a",
                              borderColor: "#52c41a",
                            }}
                            className="btn btn-block btn-lg text-white"
                          >
                            {loading ? "Creando cuenta..." : "Crear cuenta"}
                          </button>
                        </div>
                      </div>
                    </form>

                    <p className="small mt-3">
                      ¿Ya tienes cuenta?{" "}
                      <Link to="/" style={{ color: "#165afa" }}>
                        Iniciar sesión
                      </Link>
                    </p>
                    <h6 className="mt-4">© KATANA 2025</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistroDemo;
